import axios from "axios";
import Config from "../../../config/index";
import {
  GET_MIN_MAX_FAILURE_DOWNLOAD_FAILURE,
  GET_MIN_MAX_FAILURE_DOWNLOAD_REQUEST,
  GET_MIN_MAX_FAILURE_DOWNLOAD_SUCCESS,
  GET_MIN_MAX_FAILURE_FAILURE,
  GET_MIN_MAX_FAILURE_REQUEST,
  GET_MIN_MAX_FAILURE_SUCCESS,
} from "./minMaxFailureTypes";

let baseUrl = Config.baseUrl;

const getMinMaxFailureRequest = () => {
  return {
    type: GET_MIN_MAX_FAILURE_REQUEST,
  };
};

const getMinMaxFailureSuccess = (payload) => {
  return {
    type: GET_MIN_MAX_FAILURE_SUCCESS,
    payload: payload,
  };
};

const getMinMaxFailureFailure = (error) => {
  return {
    type: GET_MIN_MAX_FAILURE_FAILURE,
    payload: error,
  };
};

const getMinMaxFailure = (
  pageNo,
  rowsPerPage,
  search,
  startDate,
  endDate,
  itemCode,
  jwtToken
) => {
  let headers = { 
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getMinMaxFailureRequest());
    let url = `${baseUrl}/reports/min_max_failure?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${
      search ? search : ""
    }&filterStartDate=${startDate}&filterEndDate=${endDate}&itemCode=${itemCode}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getMinMaxFailureSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getMinMaxFailureFailure(err.message));
      });
  };
};

const downloadMinMaxFailureRequest = () => {
  return {
    type: GET_MIN_MAX_FAILURE_DOWNLOAD_REQUEST,
  };
};

const downloadMinMaxFailureSuccess = (payload) => {
  return {
    type: GET_MIN_MAX_FAILURE_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadMinMaxFailureFailure = (error) => {
  return {
    type: GET_MIN_MAX_FAILURE_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadMinMaxFailure = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  filterStartDate,
  filterEndDate,
  itemCode,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadMinMaxFailureRequest());
    let url = `${baseUrl}/reports/min_max_failure?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}&filterStartDate=${filterStartDate}&filterEndDate=${filterEndDate}&itemCode=${itemCode}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadMinMaxFailureSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadMinMaxFailureFailure(err.response));
      });
  };
};

export { getMinMaxFailure,downloadMinMaxFailure };
